import { RedirectKeys } from "../auth/authTypes";
import { logError } from "../logging";
import { parseJsonObject } from "./objectHelper";
import { getSameOriginUrl } from "./urlHelper";

interface RedirectState {
  originalPath?: string;
  origin?: string;
}

export function handleRedirectUrlState(): boolean {
  const searchParams = new URLSearchParams(window.location.search);
  const originUrl = new URL(window.location.href);

  const state = searchParams.get(RedirectKeys.State);
  if (!state) {
    return false;
  }

  const stateObj = parseJsonObject<RedirectState>(state);
  if (!stateObj) {
    logError(`State param is not a valid JSON object: ${state}`, "[handleRedirectUrlState]");
    return false;
  }

  const { originalPath, origin } = stateObj;
  const redirectUrl =
    originalPath !== undefined && origin === originUrl.origin
      ? getSameOriginUrl(originUrl.origin, originalPath)
      : undefined;

  if (redirectUrl) {
    setTimeout(() => {
      window.location.replace(redirectUrl);
    }, 500);
    return true;
  }

  return false;
}
